import { render, staticRenderFns } from "./deanRequiredFieldText.vue?vue&type=template&id=8da2601a&scoped=true"
import script from "./deanRequiredFieldText.vue?vue&type=script&lang=ts"
export * from "./deanRequiredFieldText.vue?vue&type=script&lang=ts"
import style0 from "./deanRequiredFieldText.vue?vue&type=style&index=0&id=8da2601a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da2601a",
  null
  
)

export default component.exports